import { type Dispatch, type SetStateAction } from "react"

export function toggleStateArray<T>(dispatcher: Dispatch<SetStateAction<T[]>>, item: T) {
	dispatcher(current => (current.includes(item) ? current.filter(i => i !== item) : [...current, item]))
}

export function toggleStateSet<T>(dispatcher: Dispatch<SetStateAction<Set<T>>>, item: T) {
	dispatcher(current => {
		const newSet = new Set(current)
		if (newSet.has(item)) {
			newSet.delete(item)
		} else {
			newSet.add(item)
		}
		return newSet
	})
}
